import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageStore } from './message.store';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Message, MessagesDTO } from '@ogn-tracker/common/build/message';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MessageService {
  url = environment.api + '/api/messages';

  constructor(private messageStore: MessageStore, private http: HttpClient) {
  }

  getMessages(): Observable<MessagesDTO[]> {
    return this.http.get<MessagesDTO[]>(this.url).pipe(
      tap((response) => {
        this.messageStore.update((state) => {
          return {
            ...state,
            messages: response
          };
        });
      })
    );
  }

  postMessage(body: Message): Observable<Message[]> {
    return this.http.post<Message[]>(this.url, body).pipe(
      tap((response) => {
        this.messageStore.update((state) => {
          return {
            ...state,
            messages: response
          };
        });
      })
    );
  }

  getMessageById(id: number): Observable<Message> {
    return this.http.get<Message>(this.url + '/' + id);
  }

  deleteMessageById(id: number): Observable<Message> {
    return this.http.delete<Message>(this.url + '/' + id);
  }
}
